/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Checkout_Reasons_Done1Inputs */

const vi_sitesettings_checkout_reasons_done1 = /** @type {(inputs: Sitesettings_Checkout_Reasons_Done1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn đã giao / kết thúc`)
};

/**

* @param {Sitesettings_Checkout_Reasons_Done1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_checkout_reasons_done1 = /** @type {((inputs?: Sitesettings_Checkout_Reasons_Done1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Checkout_Reasons_Done1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_checkout_reasons_done1(inputs)
});
export { sitesettings_checkout_reasons_done1 as "siteSettings_checkout_reasons_done" }